import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const disbursementsOverviewSankey: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-sankey`),
};

export default disbursementsOverviewSankey;

export const disbursementsOverviewSankeyPriority: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-sankey`),
};

export const disbursementsOverviewSankeyLocation: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-sankey`),
};

export const disbursementsOverviewSankeySector: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/disbursements-sankey`),
};
